import clipboard from 'copy-to-clipboard'
import { useCallback, useEffect, useRef, useState } from 'react'

const useCopy = () => {
  const copyTimer = useRef<any>()
  const [copied, setCopied] = useState(false)

  const copy = useCallback((val: string) => {
    clipboard(val)

    if (copyTimer.current) {
      clearTimeout(copyTimer.current)
    }

    setCopied(true)
    copyTimer.current = setTimeout(() => {
      setCopied(false)
    }, 2000)
  }, [])

  useEffect(() => {
    return () => {
      if (copyTimer.current) {
        clearTimeout(copyTimer.current)
      }
    }
  }, [])

  return {
    copy,
    copied,
  }
}

export default useCopy
